import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Rectangle, ResponsiveContainer, Cell } from 'recharts';
import { FaChartBar } from 'react-icons/fa';

const ChartDiagram = ({ agents }) => {
  // Extracting agent names and number of employees
  const data = Array.isArray(agents)
    ? agents.map((agent) => ({
        name: agent?.name || 'Unknown',
        employees: Array.isArray(agent?.Employees) ? agent.Employees.length : 0,
      }))
    : [];

  const CustomBar = (props) => {
    const { x, y, width, height, fill } = props;
    return (
        <Rectangle
            x={x}
            y={y - 10}
            width={width}
            height={height}
            fill={fill}
            radius={[12, 12, 0, 0]}
        />
    );
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className='bg-white p-3 rounded-lg shadow-lg border border-gray-200'>
          <p className='text-gray-700 font-semibold'>{payload[0].payload.name}</p>
          <p className='text-blue-600 font-bold'>Profiles: {payload[0].value}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className='w-full flex gap-2 flex-col pt-2'>
      <div className='flex items-center gap-2'>
        <FaChartBar className='text-blue-600 text-xl' />
        <h2 className='text-xl font-bold text-gray-800'>Agent Profiles Overview</h2>
      </div>
      <p className='text-gray-500 text-sm mb-1'>Distribution of employee profiles across your agents</p>
      <div className='w-full h-[260px] md:h-[330px] mb-0'>
        <ResponsiveContainer width='100%' height='100%'>
          <BarChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 60 }}>
            <CartesianGrid strokeDasharray='4 4' stroke="#e5e7eb" vertical={false} />
            <XAxis 
              dataKey='name' 
              angle={-45} 
              textAnchor="end" 
              height={100} 
              tick={{ fontSize: 12, fill: '#6b7280' }}
              axisLine={{ stroke: '#e5e7eb' }}
            />
            <YAxis 
              tick={{ fontSize: 12, fill: '#6b7280' }}
              axisLine={{ stroke: '#e5e7eb' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Bar
              dataKey='employees'
              fill='#3b82f6'
              label={{ position: 'top', fill: '#1f2937', fontSize: 12, fontWeight: 'bold' }}
              shape={CustomBar}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ChartDiagram;
